// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1k5SSot5fEGA2c {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 100%;\n}\n._12twU65I5KMWIi {\n  width: 100%;\n}\n._166k_Wd9HNgryJ {\n  margin: 0;\n  padding: 0;\n}\n._3sdjhpJZrH-KVL {\n  margin-right: 8px;\n}\n._3sdjhpJZrH-KVL input {\n  width: 84px;\n  padding: 6px;\n}\n._2pADVrz38daEqA {\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_1k5SSot5fEGA2c",
	"label": "_12twU65I5KMWIi",
	"toggleCheckbox": "_166k_Wd9HNgryJ",
	"date": "_3sdjhpJZrH-KVL",
	"closeButton": "_2pADVrz38daEqA"
};
export default ___CSS_LOADER_EXPORT___;
